"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesforceTypeRoutePart = exports.PardotTypeRoutePart = void 0;
var PardotTypeRoutePart;
(function (PardotTypeRoutePart) {
    PardotTypeRoutePart["AutomationRule"] = "automations";
    PardotTypeRoutePart["Email"] = "emails";
    PardotTypeRoutePart["EmailTemplate"] = "email-templates";
    PardotTypeRoutePart["Field"] = "fields";
    PardotTypeRoutePart["Form"] = "forms";
    PardotTypeRoutePart["LandingPage"] = "landing-pages";
    PardotTypeRoutePart["List"] = "lists";
    PardotTypeRoutePart["Object"] = "objects";
    PardotTypeRoutePart["PageAction"] = "page-actions";
    PardotTypeRoutePart["Profile"] = "profiles";
})(PardotTypeRoutePart || (exports.PardotTypeRoutePart = PardotTypeRoutePart = {}));
var SalesforceTypeRoutePart;
(function (SalesforceTypeRoutePart) {
    SalesforceTypeRoutePart["ApexClass"] = "sfApexClasses";
    SalesforceTypeRoutePart["ApexTrigger"] = "sfApexTriggers";
    SalesforceTypeRoutePart["EmailTemplate"] = "email-templates";
    SalesforceTypeRoutePart["Entity"] = "entity-definitions";
    SalesforceTypeRoutePart["Field"] = "fields";
    SalesforceTypeRoutePart["FieldUpdate"] = "field-updates";
    SalesforceTypeRoutePart["Flow"] = "flows";
    SalesforceTypeRoutePart["PageLayout"] = "page-layouts";
    SalesforceTypeRoutePart["Profile"] = "profiles";
    SalesforceTypeRoutePart["PicklistValue"] = "sfPicklistValues";
    SalesforceTypeRoutePart["ProcessBuilder"] = "flows";
    SalesforceTypeRoutePart["Report"] = "sfReports";
    SalesforceTypeRoutePart["ValidationRule"] = "validation-rules";
    SalesforceTypeRoutePart["EmailAlert"] = "workflow-alerts";
    SalesforceTypeRoutePart["WorkflowRule"] = "workflow-rules";
})(SalesforceTypeRoutePart || (exports.SalesforceTypeRoutePart = SalesforceTypeRoutePart = {}));
//# sourceMappingURL=PeriscopeRouteParts.js.map